export type WebEmbedTab = "widget" | "appearance" | "fullpage" | "fullpage-appearance";

/** Modal keys that open the Web Embed drawer, each landing on its own tab. */
const WEB_EMBED_MODAL_TABS = {
  webEmbed: "widget",
  webEmbedAppearance: "appearance",
  webEmbedFullPage: "fullpage-appearance",
} as const satisfies Record<string, WebEmbedTab>;

export type WebEmbedModalKey = keyof typeof WEB_EMBED_MODAL_TABS;

export const webEmbedTabFor = (modal: string | null): WebEmbedTab | null =>
  modal && modal in WEB_EMBED_MODAL_TABS ? WEB_EMBED_MODAL_TABS[modal as WebEmbedModalKey] : null;
